import React, { useState } from "react";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import "./dashboard.scss";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import "@fortawesome/fontawesome-free/css/all.min.css";
import LineChart from "./LineChart";
import { useAppDispatch } from "../../store/storeRequests";

import { useNavigate } from "react-router-dom";
import { hideToast, showToast } from "../../store/Toast/toast.slice";

const Dashboard: React.FunctionComponent = () => {
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [submit, setSubmit] = useState(false);
    const [dateErrors, setDateErrors] = useState({
        startDateError: "",
        endDateError: "",
    });
    const navigate = useNavigate();
    const dispatch = useAppDispatch();


    const handleDownloadAllCSV = () => {
      navigate('/anylitics');
    };

    // const handleDownloadTopTenCSV = () => {
    //     console.log("Downloading top ten users CSV");
    // };

    const handleSubmit = () => {
        // if (!startDate && !endDate) {
        //     // alert("Please select both start and end dates.");
        //     dispatch(showToast("Please select Start & End date."))
        //     setTimeout(()=>dispatch(hideToast()), 3000)
        //     // return;
        // }
        
        const today = new Date();
        let errors = { startDateError: "", endDateError: "" };

          if (!startDate) {
            errors.startDateError = "Please select a start date.";
            //     dispatch(showToast("Please select start date."))
            // setTimeout(()=>dispatch(hideToast()), 3000)
        }
        
        // Validate end date
        if (!endDate) {
            errors.endDateError = "Please select an end date.";
        } else if (endDate < startDate!) {
            errors.endDateError = "End date cannot be earlier than start date.";
        } else if (endDate > today) {
            errors.endDateError = "End date cannot be later than today.";
        }
        
        setTimeout(()=>dispatch(hideToast()), 3000)
        setDateErrors(errors);
        if (!errors.startDateError && !errors.endDateError) {
        setSubmit(!submit)
        }
    };

    return (
        <LayoutContainer title="Dashboard">
            <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
                <h2>
                    <i className="page-header-icon fa fa-dashboard "></i>
                    Dashboard
                </h2>
            </div>
            <div className="date-container font-lato">
                <div className="date-picker-wrapper font-lato">
                    <CustomDatePicker
                        label="Start Date"
                        placeholderText="Select Start Date"
                        onChange={setStartDate}
                        defaultDate={startDate}
                        dateFormat={"MMMM d, yyyy"}
                        required
                        maxDate={ endDate || new Date()}
                        className="font-lato"
                        // monthPicker={true}
                    />
                     {dateErrors.startDateError && (
                                    <div className="error-text font-12">{dateErrors.startDateError}</div>
                                )}
                </div>
                <div className="date-picker-wrapper font-lato">
                    <CustomDatePicker
                        label="End Date"
                        placeholderText="Select End Date"
                        onChange={setEndDate}
                        defaultDate={endDate}
                        dateFormat={"MMMM d, yyyy"}
                        required
                        minDate={startDate}
                        maxDate={new Date()}
                        className="font-lato"
                        // monthPicker={true}
                    />
                     {dateErrors.endDateError && (
                                    <div className="error-text font-12">{dateErrors.endDateError}</div>
                                )}
                </div>
                <button className="submit-button" onClick={handleSubmit}>
                    Submit
                </button>
                <button className="download-button" onClick={handleDownloadAllCSV}>
                    Download All CSV
                </button>
                {/* <button className="topten-user" onClick={handleDownloadTopTenCSV}>
                    Top TEN Users
                </button> */}
            </div>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    margin: "10px",
                }}
            >
                <div style={{ flex: "1 1 45%", height: "400px" }}>
                    <LineChart startDate={startDate} endDate={endDate} submit={submit} /> 
                </div>
            </div>
        </LayoutContainer>
    );
};

export default Dashboard;
